import { render, staticRenderFns } from "./ScriveAddSigningPartyFieldPlacement.vue?vue&type=template&id=95a9cd7e&scoped=true&"
import script from "./ScriveAddSigningPartyFieldPlacement.vue?vue&type=script&lang=ts&"
export * from "./ScriveAddSigningPartyFieldPlacement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a9cd7e",
  null
  
)

export default component.exports